import { render, staticRenderFns } from "./BdCrm.vue?vue&type=template&id=11a29eac&"
import script from "./BdCrm.vue?vue&type=script&lang=js&"
export * from "./BdCrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports